import React, { useContext, useState  } from "react";
import { AppProvider, AppContext } from "./context/AppContext";
import "./App.css";
import {
  BrowserRouter as Router,
  Outlet,
  Route,
  Routes,
} from "react-router-dom";

import SignIn from "./components/SignIn";
import Header from "./components/Header";
import Home from "./components/Home";
import Signup from "./components/Signup";
import NotFoundPage from "./components/NotfoundPage";
import AboutUs from "./components/AboutUs";
import Quiz from "./components/Quizz";
import EmailVerification from "./components/VerifyEmail";
import ForgetPassword from "./components/ForgetPassword";
import EducationPage from "./components/EducationPage";
import Profile from "./components/Profile";
import CookiesPolicy from "./components/Cookies";
import SuccessPayment from "./components/SuccessPayment";
import FailurePayment from "./components/FailedPayment";
import LegalPapers from "./components/legalPapers";
import HayyaPlus from "./components/HayyaPlus";
import PrivacyPolicy from "./components/PrivacyPolicy";
import TermsOfUse from "./components/TermsOfUse";
import BlogPage from "./components/Blogs";
import ContactUsForm from "./components/ContactUs";
import SignInModal from "./components/SignInModal";
import Blog1 from "./components/Blogs/Blog1";
import Blog2 from "./components/Blogs/Blog2";
import Blog3 from "./components/Blogs/Blog3";
import Blog4 from "./components/Blogs/Blog4";
import Blog5 from "./components/Blogs/Blog5";
import Checklistpage from "./components/Checklistpage";
import Checklist from "./components/CheckList";
import BudgetTracker from "./components/BudgetTracker";
import BudgetTrackerpage from "./components/BudgetTrackerpage" ;
import GuestManagement from "./components/GuestManagement";
import MariageInvitation from "./components/DMariageInvitation";
import ScrollToTop from "./components/utils/ScrollToTop";


const ProtectedRoute = () => {
  const { isAuthenticated } = useContext(AppContext);
  const [showModal, setShowModal] = useState(false);

  if (!isAuthenticated) {
    if (!showModal) {
      setShowModal(true);
    }
    return <SignInModal open={showModal} setOpen={setShowModal} />;
  }

  return (
    <>
     <Outlet />
    </>
  );
};



const AppLayout = () => (
  <>
    <Header />
    <Outlet />
  </>
);

const App = () => {
  return (
    <AppProvider>
      <Router>
      <ScrollToTop/>
        <Routes>
          <Route element={<AppLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/aboutus" element={<AboutUs />} />
            <Route path="/LegalEducation" element={<EducationPage />} />
            <Route path="/hayyaPlus" element={<HayyaPlus />} />
            <Route path="/ChecklistPage" element={<Checklistpage />} />
            <Route path="/CheckList" element={<Checklist />} />
            <Route path="/BudgetTrackerpage" element={<BudgetTrackerpage />} />
            <Route path="/BudgetTracker" element={<BudgetTracker />} />
            <Route path="/GuestManagement" element={<GuestManagement />} />
            <Route path="/DMariageInvitation" element={<MariageInvitation />} />
            <Route path="/blogs" element={<BlogPage />} />
            <Route path="/blog1" element={<Blog1 />} />
            <Route path="/blog2" element={<Blog2 />} />
            <Route path="/blog3" element={<Blog3 />} />
            <Route path="/blog4" element={<Blog4 />} />
            <Route path="/blog5" element={<Blog5 />} />
            <Route path="/contactUs" element={<ContactUsForm />} />
          </Route>
          <Route element={<ProtectedRoute />}>
            <Route path="/dashboard/:tab" element={<Profile />} />
            <Route path="/LegalPapers" element={<LegalPapers />} />
            <Route path="/quizz" element={<Quiz />} />
            <Route path="/successPayment" element={<SuccessPayment />} />
            <Route path="/failurePayment" element={<FailurePayment />} />
          </Route>
          <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
          <Route path="/TermsOfUse" element={<TermsOfUse />} />
          <Route path="/Cookies" element={<CookiesPolicy />} />
          <Route path="/signin" element={<SignIn />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/verifyEmail" element={<EmailVerification />} />
          <Route path="/forgetPassword" element={<ForgetPassword />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Router>
    </AppProvider>
  );
};

export default App;
